// Define a type for CSS styles
import React, { useEffect } from "react";

import { CompanyString, companyStrings } from "./react.company.filter";
import { DisplayFilterProps } from "@me8eon/filters/src/filters.plugin";
import { useTranslation } from "@me8eon/translation";
import { useAttributeEditorComponents } from "@me8eon/editors";
import { EonUiDropdown, EonUiDropdownOption } from "@eon-ui/eon-ui-components-react";
import { EonUiDropdownCustomEvent } from "@eon-ui/eon-ui-components";
import { useSelectedDataView } from "@me8eon/data_view_filter";
import { useUserData } from "@me8eon/react_authentication";
import { decodeEntities } from "@me8eon/string_utils";

//Later we change this to eon component
export function CompanyDisplay({ filterOps, rootId, filterName, value }: DisplayFilterProps<CompanyString>) {
    const translate = useTranslation();
    const [filterValue, setFilterValue] = filterOps;
    const selectedDataView = useSelectedDataView();
    const defaultValue = !filterValue ? selectedDataView.default?.[value ?? ""] ?? null : null;
    const size = selectedDataView.size ?? "normal";
    const userData = useUserData();
    
    return (
        <EonUiDropdown
            onValueChanged={(e: EonUiDropdownCustomEvent<string>) => {
                setFilterValue(e.target.value as CompanyString);
            }}
            value={filterValue ?? defaultValue}
            key={rootId}
            name="company_range"
            size={size}
            label={translate(`filterPage.filterMenu.searchIn`)}
            showSelectedItems={true}
            title={decodeEntities(translate(`filterPage.searchOptionsHover`))}
        >
            {companyStrings.map((company, index) => (
                <EonUiDropdownOption key={index} value={company} label={translate(`filterPage.searchOptions.${company}`).replace("<BU>", userData.company)} />
            ))}
        </EonUiDropdown>
    )
}